import type { ReaderVersionManifest } from "@nevisign/reader-core";
import { toPersianDigits } from "./ReaderToolbar";

type Props = {
  manifest: ReaderVersionManifest;
  force: boolean;
  progress?: number | null;
  busy?: boolean;
  error?: string | null;
  onUpdate: () => void;
  onDismiss?: () => void;
};

export function UpdateBanner({
  manifest,
  force,
  progress,
  busy,
  error,
  onUpdate,
  onDismiss,
}: Props) {
  const progressLabel =
    typeof progress === "number"
      ? toPersianDigits(`${Math.max(0, Math.min(100, Math.round(progress)))}`)
      : null;

  return (
    <div
      className={`update-banner${force ? " force" : ""}`}
      role="alertdialog"
      aria-label="به‌روزرسانی"
    >
      <div className="update-banner-text">
        <strong>
          {force ? "به‌روزرسانی اجباری" : "نسخهٔ جدید موجود است"}
        </strong>
        <span>
          {manifest.versionName} ({toPersianDigits(String(manifest.versionCode))})
          {manifest.notes ? ` — ${manifest.notes}` : ""}
        </span>
        {progressLabel != null && (
          <span className="update-progress">دانلود {progressLabel}٪</span>
        )}
        {error && <span className="update-error">{error}</span>}
      </div>
      <div className="update-banner-actions">
        <button
          type="button"
          className="icon-btn primary"
          disabled={busy}
          onClick={onUpdate}
        >
          {busy ? "…" : "دانلود آپدیت"}
        </button>
        {!force && onDismiss && (
          <button type="button" className="icon-btn compact" onClick={onDismiss}>
            بعداً
          </button>
        )}
      </div>
    </div>
  );
}
